<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showExportOptions"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <div
          class="fixed max-h-screen center-h-v bg-white rounded-md shadow-2xl sm:w-2/5 w-full overflow-y-auto"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
          <div
            class="flex justify-between items-center bg-primary text-white p-3 rounded-t-md"
          >
            <p class="text-base">Select/Confirm Leave Data to Download</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg"
              src="@/assets/icons/cross-white.png"
              alt="Close"
              @click="close()"
            />
          </div>
          <div class="mb-2">
            <h1 class="ml-1 font-bold">Employees</h1>
            <el-select
              v-model="selectedEmployee"
              placeholder="Select employee"
              class="w-full p-2"
              filterable
            >
              <el-option selected value="">None</el-option>
              <el-option
                v-for="employee in employees"
                :label="
                  employee.EmployeeNo +
                  ' ' +
                  decryptDataLocal(employee.Fullname, decryptionKey)
                "
                :value="employee.EmployeeNo"
                :key="employee.Id"
              ></el-option>
            </el-select>
          </div>
          <div class="mb-2 border-b-0.5 w-full">
            <h1 class="font-bold ml-1 py-2">Leave Types</h1>
          </div>
          <!-- Checkbox for exporting all leave names -->
          <div class="p-3">
            <el-checkbox
              :indeterminate="isIndeterminate"
              v-model="exportAll"
              @change="handleCheckAllChange"
              >Check all</el-checkbox
            >
          </div>

          <!-- Checkbox for each leave name -->
          <div
            v-for="leaveName in leaveNames"
            :key="leaveName"
            class="p-3 border-b"
          >
            <el-checkbox-group
              v-model="selectedLeaveNames"
              @change="handleCheckedLeaveChange"
            >
              <el-checkbox :label="leaveName" :key="leaveName">{{
                leaveName
              }}</el-checkbox>
            </el-checkbox-group>
          </div>

          <!-- Export button -->
          <div class="flex justify-end p-5 gap-2">
            <button
              type="submit"
              class="bg-primary rounded-full px-10 text-sm text-white py-2"
              @click="exportData"
            >
              Export
            </button>
            <button
              type=""
              class="bg-primary rounded-full px-10 text-sm text-white py-2"
              @click="close()"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Loader from "@/components/loader/loader.vue";
import decryptData from "@/utils/decrypt";
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  name: "CompanyDownloadLeaveData",
  props: [
    "showExportOptions",
    "leaveNames",
    "exportLeaveDatacallBack",
    "activeLeaveName",
    "close",
  ],
  components: { Loader },
  data() {
    return {
      decryptionKey: "",
      decryptDataLocal: "",
      loading: false,
      selectedLeaveNames: [],
      exportAll: false,
      isIndeterminate: true,
      employees: [],
      selectedEmployee: null,
    };
  },

  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
  },

  created() {
    this.getEmployees();
    this.decryptionKey = this.$decryptionKey;
    this.decryptDataLocal = decryptData;
  },

  watch: {
    activeLeaveName: {
      handler(newVal) {
        this.selectedLeaveNames = [newVal];
      },
      immediate: true,
    },
  },

  methods: {
    isChecked(leaveName, activeLeaveName) {
      return leaveName.trim() === activeLeaveName.trim();
    },

    exportData() {
      if (this.selectedLeaveNames.length === 0) {
        this.$notify.error({
          title: "Invalid Action",
          message: "You have not selected any leave types. Select to continue.",
        });
        return;
      }
      if (this.exportAll) {
        this.exportLeaveDatacallBack(this.leaveNames, this.selectedEmployee);
      } else {
        this.exportLeaveDatacallBack(
          this.selectedLeaveNames,
          this.selectedEmployee
        );
      }
      this.close();
    },

    handleCheckAllChange(val) {
      this.selectedLeaveNames = val ? [...this.leaveNames] : [];
      this.isIndeterminate = false;
    },
    handleCheckedLeaveChange(value) {
      let checkedCount = value.length;
      this.exportAll = checkedCount === this.leaveNames.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.leaveNames.length;
    },

    async getEmployees() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };

      try {
        const response = await axios.get(
          `${this.getOrganization}/employee/all/${this.$ApiVersion}/request`,
          options
        );

        if (response.data.StatusCode == 200) {
          this.employees = response.data.Data;

          this.loading = false;
        } else {
          this.get_error = response.data.StatusMessage;
          this.loading = false;
        }
      } catch (error) {
        this.loading = false;
        this.get_error = error.message;
      }
    },
  },
};
</script>

<style scoped></style>
